export const SET_LOOKUPS = 'SET_LOOKUPS'
export const RESET_LOOKUPS = 'RESET_LOOKUPS'
export const SET_TIMEZONES = 'SET_TIMEZONES'
export const UPSERT_LOOKUP = 'UPSERT_LOOKUP'
export const DELETE_LOOKUP = 'DELETE_LOOKUP'
export const SET_GROUPS = 'SET_GROUPS'
export const UPSERT_GROUP = 'UPSERT_GROUP'
export const SET_LOOKUPS_ZEUS = 'SET_LOOKUPS_ZEUS'
export const SET_INSURANCE_COMPANIES = 'SET_INSURANCE_COMPANIES'
export const SET_VEHICLE_MAKES = 'SET_VEHICLE_MAKES'
export const SET_ODOMETERUNITS = 'SET_ODOMETERUNITS'
export const SET_DAMAGEPOSITIONS = 'SET_DAMAGEPOSITIONS'

export const SESSION_ODOMETERUNITS = 'lookups/odometerunits'
export const SESSION_VEHICLEMAKES = 'lookups/vehiclemakes'
export const SESSION_INSURANCECOMPANIES = 'lookups/insurancecompanies'
export const SESSION_TIMEZONES = 'lookups/timezones'
export const SESSION_CANCELREASONS = 'lookups/cancelreasons'
export const SESSION_WORKORDERSTATUS = 'lookups/workorderstatus'
export const SESSION_DAMAGEPOSITIONS = 'lookups/damagepositions'
export const SESSION_CALIBRATEREASONS = 'lookups/calibratereasons'
export const SESSION_CALIBRATESYSTEMS = 'lookups/calibratesystem'
export const SESSION_CALIBRATEFIXTURES = 'lookups/calibratefixtures'
export const SESSION_CALIBRATEIMAGES = 'lookups/calibrateimages'
export const SESSION_CALIBRATENOTES = 'lookups/calibratenotes'
export const SESSION_DYNAMIC_CONFIGURATION = 'lookups/configuration'



// WEBPACK FOOTER //
// ./src/store/modules/lookups/types.js